"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeOutlookLineBreaks = void 0;

var _SanitizeConfiguration = require("../sanitizers/SanitizeConfiguration");

var isOutlookEmailWithChildren = function isOutlookEmailWithChildren(node, nodeName) {
  return nodeName === 'p' && node && node.classList && node.classList.contains('MsoNormal') && node.children && node.children.length;
};

var isEmptyBrokenParagraph = function isEmptyBrokenParagraph(node) {
  return node && !node.children.legnth && node.tagName.toLowerCase() === 'o:p' && node.innerHTML.includes('&nbsp;');
};

var isSpanWithBrokenParagraph = function isSpanWithBrokenParagraph(child) {
  return child && child.tagName.toLowerCase() === 'span' && isEmptyBrokenParagraph(child.firstElementChild);
}; // https://issues.hubspotcentral.com/browse/CRMMAIL-3503


var hasImage = function hasImage(node) {
  return !!node.getElementsByTagName('img').length;
};

var removeOutlookLineBreaks = function removeOutlookLineBreaks(_ref) {
  var node = _ref.node,
      node_name = _ref.node_name;

  if (!isOutlookEmailWithChildren(node, node_name)) {
    return null;
  }

  var child = node.firstElementChild;

  if (isEmptyBrokenParagraph(child) || isSpanWithBrokenParagraph(child)) {
    if (hasImage(node)) {
      node.removeChild(child);
      return removeOutlookLineBreaks({
        node: node,
        node_name: 'p'
      });
    }

    return {
      node: _SanitizeConfiguration.secureDocument.createElement('br')
    };
  }

  var div = _SanitizeConfiguration.secureDocument.createElement('div');

  Object.keys(node.attributes).forEach(function (key) {
    var attribute = node.attributes[key];
    div.setAttribute(attribute.nodeName, attribute.nodeValue);
  }); // https://issues.hubspotcentral.com/browse/CRMMAIL-4310

  div.innerHTML = node.innerHTML.replace(/&nbsp;/g, ' ').trim();
  return {
    node: div
  };
};

exports.removeOutlookLineBreaks = removeOutlookLineBreaks;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/removeOutlookLineBreaks.js
// module id = 814
// module chunks = 209 210 211 212